import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/h/[slug]/discussions/[threadId]/ThreadClient.jsx");
